// extracted by mini-css-extract-plugin
export var lock = "styles-module--lock--d583e";
export var text = "styles-module--text--d9080";
export var wrapper = "styles-module--wrapper--46693";